'use client';

function shouldOmitFooter({
  primaryAction,
  secondaryAction
}) {
  return !(primaryAction?.label || secondaryAction?.label);
}
export {
  shouldOmitFooter
};
